import { Outlet } from 'react-router';
import AdvancedErrorsModal from '@features/advanced-errors/AdvancedErrorsModal';
import Toolbar from '@layouts/toolbar/Toolbar';
import Footer from '@layouts/footer/Footer';



const PageLayout = () => {

	return (
		<div className="lfmt-app">

			{process.env.SHOW_ADVANCED_ERRORS === 'TRUE' &&
				<AdvancedErrorsModal />}

			<Toolbar />

			<Outlet />

			<Footer />

		</div>
	);
};

export default PageLayout;